import { type FC, useMemo, useRef } from "react";

import {
  AudienceIcon,
  Box,
  Button,
  Popover,
  PopoverBody,
  PopoverContent,
  Portal,
  useOutsideClick,
} from "@hightouch/htui";

type FunnelChartDropdownProps = {
  isOpen: boolean;
  label: string;
  position: { x: number; y: number };
  onClick: () => void;
  onClose: () => void;
};

export const FunnelChartDropdown: FC<FunnelChartDropdownProps> = ({
  isOpen,
  label,
  position,
  onClick,
  onClose,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const { x, y } = useMemo(() => {
    return {
      x: position.x,
      y: position.y,
    };
  }, [position.x, position.y]);

  useOutsideClick({
    enabled: isOpen,
    ref: containerRef,
    handler: onClose,
  });

  return (
    <Portal>
      <Box ref={containerRef} position="absolute" left={x} top={y}>
        <Popover isOpen={isOpen} initialFocusRef={buttonRef}>
          <PopoverContent width="4xs">
            <PopoverBody px={0}>
              <Box
                sx={{
                  button: {
                    fontWeight: "normal",
                    borderRadius: 0,
                    justifyContent: "start",
                    width: "100%",
                  },
                }}
              >
                <Button
                  ref={buttonRef}
                  icon={AudienceIcon}
                  variant="tertiary"
                  onClick={onClick}
                >
                  {label}
                </Button>
              </Box>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </Box>
    </Portal>
  );
};
